import { jsx } from "react/jsx-runtime";
import { forwardRef, useContext } from "react";
import assert from "assert";
import { InlineField } from "../private/InlineField/InlineField.mjs";
import { RadioGroupContext } from "../RadioGroup/RadioGroupContext.mjs";
import dedent from "dedent";
const Radio = forwardRef((props, ref) => {
  const radioGroupContext = useContext(RadioGroupContext);
  assert(
    radioGroupContext === null,
    'The "Radio" component has been deprecated. Use a "RadioItem" instead.'
  );
  if (process.env.NODE_ENV !== "production") {
    console.warn(
      dedent`
        The "Radio" component has been deprecated and will be removed in a future version. Use "RadioGroup" with "RadioItem" instead.
        %c
        - <Radio name="count" label="One" value="1" onChange={...} />
        - <Radio name="count" label="Two" value="2" onChange={...} checked />
        - <Radio name="count" label="Three" value="3" onChange={...}  />
        %c
        + <RadioGroup name="count" value="2" onChange={...}>
        +   <RadioItem label="One" value="1" />
        +   <RadioItem label="Two" value="2" />
        +   <RadioItem label="Three" value="3" />
        + </RadioGroup>
      `,
      "color: red",
      "color: green"
    );
  }
  return /* @__PURE__ */ jsx(
    InlineField,
    {
      ...props,
      inList: false,
      type: "radio",
      message: null,
      reserveMessageSpace: false,
      required: void 0,
      size: void 0,
      ref
    }
  );
});
Radio.displayName = "Radio";
export {
  Radio
};
